import { Div2Floor } from "../utils/Div2Floor";
import {
  enumButtonLabelPosition,
  enumElementBorderStyle,
  enumElementDrawStates,
  kCheckEnabled,
  kfontIconNameRegularMedium
} from "../constants";
import { QButton } from "./QButton";
import { shadeColor } from "../utils/shadeColor";
import { SetCtxFont } from "../utils/SetCtxFont";
import { Globals } from "./Globals.js";
import { DetermineBrightness } from "../utils/DetermineBrightness.js";
export class QFAButton extends QButton {
  constructor() {
    super();
    this.fDrawPad = false;
    this.fBorderStyle = enumElementBorderStyle.noBorder; /// change to single border for padded
  }

  InitButton(parent, label, cmdCode, x, y, width, height, fontStyle) {
    this.fWSMgr = parent.GetWSMgrRef();
    this.fUIColors = this.fWSMgr.GetUIColors();
    this.SetFontColor(this.fUIColors.GetFontIconColor());
    this.fFontString = fontStyle ? fontStyle : kfontIconNameRegularMedium;
    this.SetCmdCode(cmdCode);
    this.SizeElement(width, height);
    this.AutoSize();
    this.PositionElement(x, y);
    this.SetLabel(label);
    parent.PushElement(this);
  }

  SetHoverColor(hoverColor) {
    this.fHoverColor = hoverColor;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    var drawState = this.GetDrawState();
    var textGlow = true;
    var txtFillStyle =
      this.fTxtFillStyle != null ? this.fTxtFillStyle : Globals._themeMode.text.header;

    if (this.fDrawPad) {
      var padColor = this.fFillColor;
      ctx.strokestyle = this.fUIColors.GetButtonBorderColor();
      ctx.lineWidth = 1;

      switch (drawState) {
        case enumElementDrawStates.Std:
          break;
        case enumElementDrawStates.MouseDown:
          padColor = shadeColor(padColor, -30);
          break;
        case enumElementDrawStates.Hover:
          padColor = this.fHoverColor ? this.fHoverColor : shadeColor(padColor, -20);
          ctx.lineWidth = 2;
          break;
        case enumElementDrawStates.Disabled:
          ctx.globalAlpha = 0.6;
          break;
      }
      ctx.fillStyle = padColor;
      ctx.fill(this.fClippedRegion);
      ctx.globalAlpha = 1;
      textGlow = false;
    }

    switch (drawState) {
      case enumElementDrawStates.Std:
        txtFillStyle = shadeColor(txtFillStyle, this.fIsActive || this.fSelected ? 50 : 0);
        break;
      case enumElementDrawStates.MouseDown:
        txtFillStyle = shadeColor(txtFillStyle, -20);
        break;
      case enumElementDrawStates.Hover:
        if (textGlow) {
          var shadePercent = DetermineBrightness(txtFillStyle) > 100 ? 30 : 100;
          txtFillStyle = this.fHoverColor
            ? this.fHoverColor
            : shadeColor(txtFillStyle, shadePercent);
          ctx.shadowColor = txtFillStyle;
        }
        break;
      case enumElementDrawStates.Disabled:
        ctx.globalAlpha = 0.7;
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }

    ctx.fillStyle = txtFillStyle;
    var fontString = this.fFontString != null ? this.fFontString : kfontIconNameRegularMedium;

    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";

    var txtHOffset = Div2Floor(this.fWidth);
    var txt = this.fLabel;
    var labelText = txt;
    var xPos, yPos;
    switch (this.fLabelPosition) {
      case enumButtonLabelPosition.below:
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight - 4;
        break;
      case enumButtonLabelPosition.center:
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + txtHOffset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      case enumButtonLabelPosition.left:
        var labelW = this.MeasureLabel();
        var txtHIndent = 6;
        ctx.textBaseline = "middle";
        xPos = this.fHorzOffset + labelW / 2 + txtHIndent + this.fLabelInset;
        yPos = this.fVertOffset + this.fHeight / 2;
        break;
      default:
        xPos = this.fHorzOffset;
        yPos = this.fVertOffset;
        break;
    }
    SetCtxFont(ctx, fontString);
    ctx.fillText(labelText, xPos, yPos, this.GetWidth());

    ctx.shadowBlur = 0;
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  GetRealContent() {
    //Used to simplify true/false checks. Semi-dirty...
    return !(this.fLabel == kCheckEnabled);
  }
}
